<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>

                <b-card no-body :header="$t('general.calculation.steel_structure.title')" header-tag="h3" class="bg-default-card">
                    <span v-if="showTableBarLoader">
                        <BarLoader 
                            class="my-custom-bar-loader"
                            :color="'#6f9fe6'"
                        >
                        </BarLoader>
                    </span>
                    <span style="padding: 1.25rem;" v-if="steel.show" :class="showTableBarLoader ? 'disabled-custom-class' : ''">
                        <div class="row">
                            <div class="col-lg-3 mt-1">
                                <label>{{$t('table.filter_by_company')}}</label>
                            </div>
                            <div class="col-lg-9">
                                <multiselect v-model="steel.filter"
                                    :options="companies"
                                    :multiple="false"
                                    :clear-on-select="true"
                                    :hide-selected="false"
                                    :loading="isCompaniesLoading"
                                    :preserve-search="true"
                                    placeholder=""
                                    label="name" track-by="id"
                                    :selectLabel="''"
                                    @input="updateFilterCompany('steel', ...arguments)"
                                >
                                    <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                    <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                                </multiselect>
                            </div>
                        </div>

                        <data-table-collapse
                            title=""
                            :search="false"
                            :exportable="this.$store.getters.hasPermission(['project_calculation_overview_steel'], ['read'])"
                            :rows="steel.rows"
                            :columns="steel.data"
                            :perPage="steel.perPage"
                            :rowsCount="steel.rowsCount"
                            :currentPage="steel.currentPage"
                            :pageCount="steel.pageCount"

                            :grandTotal="true"
                            :grandTotalData="steel.grandTotal"
                            :rowChangeSelectOptions="rowChangeSelectOptions"
                            @rowChangeSelect="rowChangeSelect('steel', ...arguments)"
                            @rowChangeUpdate="rowChangeUpdate('steel', ...arguments)"
                            @subRowClick="subRowClick('steel', ...arguments)"
                            @rowCheckboxAutoUpdate="rowCheckboxAutoUpdate('steel', ...arguments)"

                            @changePage="changePage('steel', ...arguments)"
                            @searchEvent="searchEvent('steel', ...arguments)"
                            @orderByEvent="orderByEvent('steel', ...arguments)"
                            @exportButtonClick="onExportButton('steel', ...arguments)"
                        >
                        </data-table-collapse>

                        <b-btn class="btn btn-dark mt-3 mr-2" v-if="this.$store.getters.hasPermission(['project_progress_calculation_steel'], ['read'])" @click="goToCalculation">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ $t('general.buttons.go_to.go_to_steel_structure_calculation') }}
                        </b-btn>

                        <b-btn class="btn btn-default mt-3 mr-2" @click="onAddRow('steel', ...arguments)" v-if="this.$store.getters.hasPermission(['project_calculation'], ['create'])">
                            <i class="fa fa-plus-circle mr-1"></i> {{ $t('general.commercial.calculation.create_button.steel') }}
                        </b-btn>
                    </span>
                </b-card>
            </div>
        </div>

        <calculation-modal 
        :actionTitle="actionTitle" 
        :model.sync="model" 
        :currentListId="steel.rows" 
        addType="steel" 
        @onLoadTable="onLoadTable" 
        ref="calculationModal"/>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTableCollapse from '@/components/global/tables/datatables/DataTableCollapse.vue';
import Multiselect from 'vue-multiselect';
import miniToastr from 'mini-toastr';
import http from '@/libs/http';
import _ from 'lodash';
import CalculationModal from '@/components/global/modals/CalculationModal.vue';
import { BarLoader } from '@saeris/vue-spinners';

export default {
    name: 'overview_steel',
    components: {
        Multiselect,
        DataTableCollapse,
        ConfirmDialog,
        CalculationModal,
        BarLoader,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.calculation.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.calculation.steel_structure.title'),
                    active: true
                },
            ],
            showTableBarLoader: false,
            companies: [],
            only_companies: [],
            
            rowChangeSelectOptions: {company_id: [], percent_finished: []},
                        
            isCompaniesLoading: false,
            filters: {},
            all_sections: {},

            main_index: null,
            main_type: null,

            actionTitle: '',

            model: {
                add_type: '',
                id: null,
                company_id: null,
                note: null,
                type: null,
                type_id: null,
                list_id: null,
                quantity: null,
                subcontractor_material_price: null,
                subcontractor_work_price: null,
                subcontractor_other_price: null,
                subcontractor_currency: null,

                part_number: null,
                part_description: null,
                part_material: null,
                part_size: null,
                part_thk: null,
                part_sizer: null,
                part_thkr: null,
                part_standard: null,
                part_dimension: null,
                weld_type_id: null,
                weld_place: null,
                weld_size: null,
                weld_dimension: null,
                weld_standard: null,
                weld_material_id: null,
                equipment: null,
                equipment_item_no: null,
                equipment_description: null,
                part_data_id: null,
                part_data_hl: null,
                part_data_insul: null,
                part_painting_no: null,
                part_painting_description: null,
                part_painting_code: null,
                part_painting_thickness: null,
                part_painting_color: null,
                scaffolding_part_no: null,
                scaffolding_part_description: null,
                scaffolding_part_length: null,
                scaffolding_part_width: null,
                scaffolding_part_height: null,
                part_insulation_no: null,
                part_insulation_description: null,
                part_insulation_type: null,
                part_insulation_thickness: null,
                part_insulation_code: null,
                tie_in_description: null,
                elevation: null,
                measureunit: null,
                unitweight: null,
                remarks1: null,
                remarks2: null,
                percent_finished: null,
                selectedCompany: null,
                selectedListId: null,
                selectedPriceTypeId: null,
                selectedProjectSetting: null,
                selectedWeldMaterial: null,
            },

            steel: {
                rows: [],
                perPage: 0,
                rowsCount: 0,
                currentPage: 1,
                pageCount: 1,
                searchInput: '',
                sortType: 'asc',
                sortBy: 'id',
                show: false,
                data: [
                    {
                        label: Vue.i18n.translate('misc.actions'),
                        field: 'click_to_open',
                        clickable: true,
                        html: true,
                        sortable: false,
                    },
                    {
                        label: Vue.i18n.translate('table.structure_number'),
                        field: 'structure_number',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.drawing_number'),
                        field: 'drawing_number',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.structure_name'),
                        field: 'structure_name',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.total_price_work'),
                        field: 'total_price_work',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.total_price_material'),
                        field: 'total_price_material',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.total_price_others'),
                        field: 'total_price_others',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.total_price'),
                        field: 'total_price',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.total_hours_calculated'),
                        field: 'total_hours_calculated',
                        numeric: false,
                        html: false,
                    }
                ]
            }
        }
    },
    mounted() {
        if (!this.$store.getters.hasPermission(['project_prices'])) {
            this.steel.data = [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    field: 'click_to_open',
                    clickable: true,
                    html: true,
                    sortable: false,
                },
                {
                    label: Vue.i18n.translate('table.structure_number'),
                    field: 'structure_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.drawing_number'),
                    field: 'drawing_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.structure_name'),
                    field: 'structure_name',
                    numeric: false,
                    html: false,
                },
            ]
        }

        this.onLoadTable();
        this.getPercentsSelect();
        this.getCompanies();
    },
    methods: {
        getPercentsSelect () {
            var percents = [];
            for (var i=0; i<=100; i++) {
                percents.push({id: i, name: i + ' %'});
            }

            this.rowChangeSelectOptions['percent_finished'] = percents;
        },
        getCompanies () {
            this.isCompaniesLoading = true;
            http.route('company?project_id=' + this.$route.params.id + '&subcontractors=1').get()
            .then(response => {
                if (!response.isError) {
                    var default_filter_options = [];
                    default_filter_options.push({'id': '', 'name': Vue.i18n.translate('misc.all')});
                    default_filter_options.push({'id': 'seller', 'name': Vue.i18n.translate('misc.seller')});
                    default_filter_options.push({'id': 'other', 'name': Vue.i18n.translate('misc.all_others')});
                    var filter_options = [];
                    var filter_options2 = [];

                    filter_options = default_filter_options;
                    if (response.data != false) {
                        let data = response.data;
                        data.forEach(field => {
                            filter_options.push(field);
                            filter_options2.push(field);
                        });
                    }

                    this.only_companies = filter_options2;
                    this.rowChangeSelectOptions['company_id'] = filter_options2;
                    this.companies = filter_options;
                    this.isCompaniesLoading = false;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        updateFilterCompany(type, entry) {
            if (typeof this.filters[type] == 'undefined') {
                this.filters[type] = {};
            }
            this.filters[type]['company_id'] = (entry != null) ? entry.id : '';
            this.onLoadTable(type, true);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 4000);
        },
        orderByEvent(type, column, sort_type) {
            this[type].sortType = sort_type;
            this[type].sortBy = column.field;
            this.onLoadTable(type);
        },
        searchEvent(type, searchInput) {
            this[type].searchInput = searchInput;
            this.onLoadTable(type);
        },
        changePage(type, page) {
            this[type].currentPage = page;
            this.onLoadTable(type);
        },
        onLoadTable(type, filtered = false) {
            this.showTableBarLoader = true;
            http.route('project_calculation_steel?project_id='+this.$route.params.id+'&search='+this.steel.searchInput+'&page='+this.steel.currentPage+'&sort_by='+this.steel.sortBy+'&sort_order='+this.steel.sortType+'&filters[company_id]='+(typeof this.filters['steel'] != 'undefined' ? this.filters['steel'].company_id : '')+'&filters[type]=null').get().then(response => {
                if (!response.isError) {
                    this.steel.perPage     = response.pagination.limit;
                    this.steel.rowsCount   = response.pagination.totalEntries;
                    this.steel.currentPage = response.pagination.currentPage;
                    this.steel.pageCount   = response.pagination.totalPages;
                    var vm = this;

                    let data = response.data;
                    data.forEach(field => {
                        if (typeof response.other != 'undefined') {
                            if (typeof response.other.collapsible_headers != 'undefined') {
                                field.collapsible_headers = response.other.collapsible_headers;
                            }
                            if (typeof response.other.grand_total != 'undefined') {
                                vm.steel.grandTotal = response.other.grand_total;
                            }
                            vm.all_sections = response.other.sections;
                        }
                    });

                    this.steel.rows = data;
                    this.steel.show = true;

                    if (filtered) {
                        this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
                    }
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }

                this.showTableBarLoader = false;
            });
        },
        rowChangeSelect(type, index, company, value) {
            switch(type) {//update info then refresh
                default:
                    index[company] = value;
                    index['project_id'] = this.$route.params.id;
                    http.route('project_calculation/' + index.id).patch(index, true).then(response => {
                        if (response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.successMsg(Vue.i18n.translate('table.calculation') + ' ' + Vue.i18n.translate('messages.updated'));
                        }
                        this.onLoadTable(type);
                    });
                    break;
            }
        },
        rowChangeUpdate(type, index, key, value) {
            switch(type) {//update info then refresh
                default:
                    index[key] = value;
                    index['project_id'] = this.$route.params.id;
                    http.route('project_calculation/' + index.id).patch(index, true).then(response => {
                        if (response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.successMsg(Vue.i18n.translate('table.calculation') + ' ' + Vue.i18n.translate('messages.updated'));
                        }
                        this.onLoadTable(type);
                    });
                    break;
            }
        },
        rowCheckboxAutoUpdate(type, index, action) {
            if (typeof action != 'undefined') {
                index[action] = !index[action];
                http.route('project_calculation/' + index.id).patch(index, true).then(response => {
                    if (response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.successMsg(Vue.i18n.translate('table.calculation') + ' ' + Vue.i18n.translate('messages.updated'));
                    }
                    this.onLoadTable(type);
                });
            }
        },
        subRowClick(type, index, action) {
            switch(type) {//update info then refresh
                default:
                    switch(action) {
                        case 'delete':
                        this.main_type = type;
                        this.main_index = index;
                        this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('table.steel') + ' ' + Vue.i18n.translate('table.calculation');
                        this.$refs.deleteModal.show();
                            break;
                        case 'duplicate':
                            this.actionTitle = Vue.i18n.translate('modal.general.duplicate') + ' ' + Vue.i18n.translate('table.steel') + ' ' + Vue.i18n.translate('table.calculation');
                            this.clearSearches();

                            this.row = null;
                            this.add_type = type;
                            this.model.id = null;
                            this.model.company_id = null;
                            
                            if (index.company_id) {
                               this.model.company_id = index.company_id;
                               for (var i = 0; i<this.only_companies.length;i++) {
                                   if (this.only_companies[i].id == index.company_id) {
                                       this.model.selectedCompany = {name: this.only_companies[i].name, id: index.company_id};
                                   }
                               }
                            }

                            if (index.list_id) {
                               this.model.list_id = index.list_id;
                               this.model.selectedListId = {info: index.list_id_name, id: index.list_id};
                            }
                            
                            this.model.selectedPriceTypeId          = null;
                            this.model.type_id                      = null;
                            this.model.company_id                   = index.company_id;
                            this.model.type                         = index.type;
                            this.model.section                      = index.section;
                            this.model.quantity                     = index.quantity;
                            this.model.subcontractor_material_price = index.subcontractor_material_price;
                            this.model.subcontractor_work_price     = index.subcontractor_work_price;
                            this.model.subcontractor_other_price    = index.subcontractor_other_price;
                            this.model.subcontractor_currency       = index.subcontractor_currency;

                            this.model.part_number                  = index.part_number;
                            this.model.part_description             = index.part_description;
                            this.model.part_material                = index.part_material;
                            this.model.part_size                    = index.part_size;
                            this.model.part_thk                     = index.part_thk;
                            this.model.part_sizer                   = index.part_sizer;
                            this.model.part_thkr                    = index.part_thkr;
                            this.model.part_standard                = index.part_standard;
                            this.model.part_dimension               = index.part_dimension;
                            this.model.weld_type_id                 = index.weld_type_id;
                            this.model.weld_place                   = index.weld_place;
                            this.model.weld_size                    = index.weld_size;
                            this.model.weld_dimension               = index.weld_dimension;
                            this.model.weld_standard                = index.weld_standard;
                            this.model.weld_material_id             = index.weld_material_id;
                            this.model.equipment                    = index.equipment;
                            this.model.equipment_item_no            = index.equipment_item_no;
                            this.model.equipment_description        = index.equipment_description;
                            this.model.part_data_id                 = index.part_data_id;
                            this.model.part_data_hl                 = index.part_data_hl;
                            this.model.part_data_insul              = index.part_data_insul;
                            this.model.part_painting_no             = index.part_painting_no;
                            this.model.part_painting_description    = index.part_painting_description;
                            this.model.part_painting_code           = index.part_painting_code;
                            this.model.part_painting_thickness      = index.part_painting_thickness;
                            this.model.part_painting_color          = index.part_painting_color;
                            this.model.scaffolding_part_no          = index.scaffolding_part_no;
                            this.model.scaffolding_part_description = index.scaffolding_part_description;
                            this.model.scaffolding_part_length      = index.scaffolding_part_length;
                            this.model.scaffolding_part_width       = index.scaffolding_part_width;
                            this.model.scaffolding_part_height      = index.scaffolding_part_height;
                            this.model.part_insulation_no           = index.part_insulation_no;
                            this.model.part_insulation_description  = index.part_insulation_description;
                            this.model.part_insulation_type         = index.part_insulation_type;
                            this.model.part_insulation_thickness    = index.part_insulation_thickness;
                            this.model.part_insulation_code         = index.part_insulation_code;
                            this.model.tie_in_description           = index.tie_in_description;
                            this.model.elevation                    = index.elevation;
                            this.model.measureunit                  = index.measureunit;
                            this.model.unitweight                   = index.unitweight;
                            this.model.remarks1                     = index.remarks1;
                            this.model.remarks2                     = index.remarks2;
                            this.model.percent_finished             = index.percent_finished;
                            this.model.note                         = index.note;

                            this.$refs.calculationModal.isDuplicate = true;

                            this.$refs.calculationModal.show();
                            break;
                    }
                    break;
            }
        },
        clearSearches () {
            this.model.selectedCompany = null;
            this.model.selectedListId = null;
            this.model.selectedPriceTypeId = null;
        },
        onAddRow(type) {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('table.steel') + ' ' + Vue.i18n.translate('table.calculation');
            this.row                                = null;
            this.model.add_type                     = type;
            this.model.company_id                   = null;
            this.model.type                         = null;
            this.model.section                      = null;
            this.model.type_id                      = null;
            this.model.list_id                      = null;
            this.model.id                           = null;
            this.model.quantity                     = null;
            this.model.subcontractor_material_price = null;
            this.model.subcontractor_work_price     = null;
            this.model.subcontractor_other_price    = null;
            this.model.subcontractor_currency       = null;

            this.model.part_number                  = null;
            this.model.part_description             = null;
            this.model.part_material                = null;
            this.model.part_size                    = null;
            this.model.part_thk                     = null;
            this.model.part_sizer                   = null;
            this.model.part_thkr                    = null;
            this.model.part_standard                = null;
            this.model.part_dimension               = null;
            this.model.weld_type_id                 = null;
            this.model.weld_place                   = null;
            this.model.weld_size                    = null;
            this.model.weld_dimension               = null;
            this.model.weld_standard                = null;
            this.model.weld_material_id             = null;
            this.model.equipment                    = null;
            this.model.equipment_item_no            = null;
            this.model.equipment_description        = null;
            this.model.part_data_id                 = null;
            this.model.part_data_hl                 = null;
            this.model.part_data_insul              = null;
            this.model.part_painting_no             = null;
            this.model.part_painting_description    = null;
            this.model.part_painting_code           = null;
            this.model.part_painting_thickness      = null;
            this.model.part_painting_color          = null;
            this.model.scaffolding_part_no          = null;
            this.model.scaffolding_part_description = null;
            this.model.scaffolding_part_length      = null;
            this.model.scaffolding_part_width       = null;
            this.model.scaffolding_part_height      = null;
            this.model.part_insulation_no           = null;
            this.model.part_insulation_description  = null;
            this.model.part_insulation_type         = null;
            this.model.part_insulation_thickness    = null;
            this.model.part_insulation_code         = null;
            this.model.tie_in_description           = null;
            this.model.elevation                    = null;
            this.model.measureunit                  = null;
            this.model.unitweight                   = null;
            this.model.remarks1                     = null;
            this.model.remarks2                     = null;
            this.model.percent_finished             = null;
            this.model.note                         = null;
            this.model.selectedProjectSetting       = null;
            this.model.selectedWeldMaterial         = null;
            this.$refs.currentProjectSetting        = [];
            this.$refs.currentWeldMaterial          = [];
            this.$refs.calculationModal.isDuplicate = false;
            
            this.clearSearches();
            this.$refs.calculationModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                http.route('project_calculation/' + this.main_index.id).delete().then(response => {
                    if (response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.successMsg(Vue.i18n.translate('table.calculation') + ' ' + Vue.i18n.translate('messages.deleted'));
                    }
                    this.onLoadTable(this.main_type);
                    this.main_type = null;
                    this.main_index = null;
                });
            }
            this.$refs.deleteModal.hide();
        },
        onExportButton(type) {
            let put_data = {
                export: 1,
                type: type,
                project_id: this.$route.params.id,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType,
            };
            
            if (typeof this.filters[type] != 'undefined') {
                for (var k in this.filters[type]) {
                    put_data['filters['+k+']'] = this.filters[type][k];
                }
            }

            http.route('project_calculation_steel').exportExcel(put_data, 'overview_steel_structure.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    if (response.data == false) {
                        this.errorMsg(Vue.i18n.translate('errors.export_error'));
                    } 
                } else {
                    this.successMsg(Vue.i18n.translate('general.calculation.steel_structure.title')  + ' ' + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        goToCalculation() {
            this.$router.push('/project/'+this.$route.params.id+'/progress/calculation/steel');
        },
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    select {
        -webkit-appearance: menulist-button;
        -moz-appearance: menulist-button;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/commercial/calculation/overview_steel.vue